import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitleComponent from "./PageTitleComponent";
import "../styles/ErrorPageComponent.css";

export default function ErrorPageComponent({ code }) {
  const { t } = useTranslation();
  const { code: routeCode } = useParams();
  const requestedCode = String(code || routeCode || "404");
  const errorCode = ["403", "404", "500", "503"].includes(requestedCode)
    ? requestedCode
    : "404";

  return (
    <PageTitleComponent title={`errors.${errorCode}.title`}>
      <section className="error-page" aria-labelledby="error-page-title">
        <div className="error-page-card">
          <p className="error-page-code">{errorCode}</p>
          <h1 id="error-page-title">{t(`errors.${errorCode}.title`)}</h1>
          <p className="error-page-description">
            {t(`errors.${errorCode}.description`)}
          </p>
          <div className="error-page-actions">
            <Link className="error-page-home" to="/">
              {t("errors.home")}
            </Link>
            {(errorCode === "500" || errorCode === "503") && (
              <button
                className="error-page-reload"
                type="button"
                onClick={() => window.location.reload()}
              >
                {t("errors.reload")}
              </button>
            )}
          </div>
        </div>
      </section>
    </PageTitleComponent>
  );
}
